module.exports = __webpack_public_path__ + "static/media/menu.04690416.svg";